import React, { useEffect } from "react";
import { Grid, Card } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { Typography, Box, Button } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import { useDispatch } from "react-redux";
import { cartItemDeleteAction } from "actions/cartAction";
import { Add, Remove } from "@mui/icons-material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { IMAGE_BASE_URL } from "config";
import { moneyFormatter } from "../../utils/formatUtils";
import { addToCartAction } from "../../actions/cartAction";
import { useSelector } from "react-redux";
import Price from "components/Price";


const CartItems = ({ item, index, getCartAction, cartItems }) => {

  const isShowProductPrice = useSelector((state)=> state.app.showProductPrice);
  const isTaxInclusivePrice = useSelector((state)=> state.app.isTaxInclusivePrice);
  const theme = useTheme();
  const mobileView = useMediaQuery(theme.breakpoints.up("sm"));
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);
  const [value, setValue] = React.useState(item?.quantity);

  const handleClickOpen = (index) => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setValue(item?.quantity);
  };

  const cartItemDelete = (productId) => {
    try {
      dispatch(cartItemDeleteAction(productId));
    } catch {
      console.log("error");
    }
    handleClose();
  };

  if (item?.quantity == 0) {
    setOpen(true);
    setValue(0);
  }

  //   const priseGrid = {
  //     display: "flex",
  //     alignItems: "center",
  //   };
  // const priseGridMobile ={
  //   display: "flex",
  //     alignItems: "end",
  //     marginTop:'-35px'
  //   }
  const productId = item?.productId;
  const quantity = item?.quantity;
  const description = item?.description;

  const incrementCart = () => {
    const newValue = value + 1;
    setValue(newValue);
    dispatch(addToCartAction(productId, newValue, description));
  };

  const decrementCart = () => {
    const newValue = value - 1;
    if (newValue == 0) {
      setOpen(true);
    }
    setValue(newValue);
    dispatch(addToCartAction(productId, newValue, description));
  };

  useEffect(() => {}, [cartItems, value, item]);

  const isMobileView = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Card sx={{ borderRadius: 2, p: 0, mb: 4 }} elevation={4}>
      <Grid container spacing={0} key={item.index}>
        <Grid
          item
          xs={12}
          sm={3}
          md={2}
          xl={3}
          sx={{ display: "flex", alignItems: "center" }}
        >
          
          
          <Card elevation={3} sx={{ width: isMobileView ? "100%" : "280px", height: isMobileView ? "280px" : "240px" }}>
            <CardMedia
              component="img"
              // sx={{ maxWidth: "100%", maxHeight: "100%" }}
              width="100%"
              height="100%"
              textAlign="center"
              // image="data:image/jpeg;base64,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"
              // image= {item.baseImageUrl}
              image={IMAGE_BASE_URL + "/" + item?.baseImageUrl || '/assets/defaults/mperito_defualt_product.png'}
              alt="product image"
            />
          </Card>
          {/* </Box> */}
        </Grid>

        <Grid item xs={12} sm={5} md={5} xl={5} sx={{display:'flex', justifyContent:'start'}}>
          <CardContent sx={{ textAlign: "left" }} spacing={4}>
            <Typography component="div" variant="h6" sx={{ mt: 1 }}>
              {item?.brand}
            </Typography>
            {/* <Typography
              variant="subtitle2"
              color="text.secondary"
              component="div"
              sx={{ mt: 1 }}
            >
              {item?.Number}
            </Typography> */}
            <Box>
              <Typography
                variant="CardTitle"
                color="text.secondary"
                sx={{ mb: 3 }}
              >
                {item?.productName}
              </Typography>
            </Box>
            <Box sx={{ mt: 1 }}>
              <Typography variant="CardSKU" color="text.secondary">
                {item?.productSKU}
              </Typography>
            </Box>
            {/* {isShowProductPrice && 
            <Typography
              sx={{ display: "flex", mt: 2 }}
              component="div"
              variant="CardTitle"
            >
              {moneyFormatter(item?.total)}
            </Typography>
            } */}
            {isShowProductPrice && (
              <>
                <Price
                  price={item?.priceDetail?.sellPrice}
                  specialPrice={item?.priceDetail?.specialPrice?.price}
                  fromDate={item?.priceDetail?.specialPrice?.from}
                  tillDate={item?.priceDetail?.specialPrice?.till}
                  discount={item?.priceDetail?.specialPrice?.discount}
                />
                <Typography variant="body2" gutterBottom>
                  {isTaxInclusivePrice ? "Inclusive of all taxes" : ""}
                </Typography>
              </>
            )}

            <Box sx={{mt:2}}>
            {item.variations.map((list)=>{
              const [key, value] = Object.entries(list)[0];
              return(
                <Box sx={{display:"flex"}}>
                <Typography variant="body2" gutterBottom sx={{fontWeight: "bold"}}>{key} :{""} </Typography>
                <Typography variant="body2" gutterBottom>{""} {value}</Typography>
                </Box>
              )
            }
            )}
            </Box>


            
          </CardContent>
        </Grid>


        <Grid item xs={12} sm={3} md={3} xl={3} sx={{display:'flex', alignItems:'start', justifyContent:'center'}}>
        {isShowProductPrice && 
            <Box sx={{ display: "flex", mt: 2 }}>
              <IconButton
                aria-label="delete"
                size="small"
                sx={{ backgroundColor: "primary.main" }}
                onClick={decrementCart}
              >
                <Remove fontSize="inherit" />
              </IconButton>

              <Typography sx={{ ml: 1 , alignItems:'center'}}>
                <input
                  type="number"
                  value={value}
                  style={{
                    width: "60px",
                    fontWeight: "800",
                    fontSize: "18px",
                    border: "none",
                    marginTop : "3px",
                    textAlign: "center"
                  }}
                  onChange={(e) => setValue(e.target.value)}
                />
              </Typography>

              <IconButton
                aria-label="delete"
                size="small"
                sx={{ backgroundColor: "primary.main" }}
                onClick={incrementCart}
              >
                <Add fontSize="inherit" />
              </IconButton>
            </Box>
          }
</Grid>
        {/* <Grid
          item
          xs={9}
          sm={9}
          md={2}
          xl={2}
          
          sx={{ display: "flex", alignItems: "center" }}
        >
          <CardContent>
            <Typography
              component="div"
              variant="CardTitle"
              sx={{ display: "flex", }}
            >
              

              {moneyFormatter(item?.total)}
              
            </Typography>
          </CardContent>
        </Grid> */}
        <Grid
          item
          xs={12}
          sm={12}
          md={2}
          xl={2}
          sx={{ display: "flex", alignItems: "start", justifyContent: "end" }}
        >
          <IconButton aria-label="delete">
            <DeleteIcon onClick={() => handleClickOpen(index)} />
          </IconButton>
        </Grid>
      </Grid>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Want to Delete item from cart
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" size="small" onClick={handleClose}>
            No
          </Button>
          <Button
            variant="contained"
            size="small"
            onClick={() => cartItemDelete(item.productId)}
            autoFocus
          >
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </Card>
  );
};

export default CartItems;
